import { Component, Input } from '@angular/core';

@Component({
  selector: 'kp-diamond',
  templateUrl: './diamond.component.html',
  styleUrls: ['./diamond.component.scss'],
})
export class DiamondComponent {
  @Input() appearDisabled = false;
  @Input() index: number;
  @Input() isDiamondCard = false;
  @Input() isDisabled = false;
  @Input() isMilestone = false;
  @Input() isSelected: boolean;
  @Input() milestoneDiamondIndicator = false;
  @Input() milestoneIndex: number;
  @Input() order: string;
  @Input() text: string;
}
